export const SET_HORIZONTAL_LEVEL_TO_DISPLAY =
  'SET_HORIZONTAL_LEVEL_TO_DISPLAY';

export const setHorizontalLevelToDisplay = (
  horizontalLevelToDisplay: string,
) => ({
  type: SET_HORIZONTAL_LEVEL_TO_DISPLAY,
  data: horizontalLevelToDisplay,
});
